
import ListView from './listview'
import Search from 'vux/src/components/search/index.vue'

export default {
data() {
return {
singers:[],
address:[],
dataca:this.datac,
HOT_NAME: localStorage.getItem("$currentCity") ? '#<img src="./static/img/posicc.png" class="ico_posi_c">所在地及周边车站' : ""
}
},
created() {
this._getSingerList()
},
props:['datac','serach'],
computed:{
singersc:function(){
var search = this.serach;
if (search){
return this._normalizeSinger(this.dataca.filter(function(product){
return Object.keys(product).some(function(key){
return String(product[key]).toLowerCase().indexOf(search) > -1
})
}))
}
return this.singers;
}
},
methods:{
handlePlaylist(playlist) {
const bottom = playlist.length > 0 ? '60px' : ''
this.$refs.city.style.bottom = bottom
this.$refs.list.refresh()
},
selectc(ac){
var path = this.$store.state.mutations.path;

var jbStorage = JSON.parse(window.localStorage.getItem("jbStorage"));
if (path === "pickupStation"){
if(jbStorage) {
jbStorage.upvalue = {
"cityNo": ac.id,
"siteName":ac.name,
"siteNo": ac.siteNo
}
}else{
jbStorage = {
"upvalue": {
"cityNo": ac.id,
"siteName":ac.name,
"siteNo": ac.siteNo
}
}
}
}
if (path === "giveawayStation"){
jbStorage.downvalue = {
"cityNo":ac.id,
"siteName":ac.name,
"siteNo":ac.siteNo
}
}

window.localStorage.setItem("jbStorage",JSON.stringify(jbStorage));

if(this.$until.judgeBrowser() == "weixin"){
setTimeout(()=>{
this.$router.push("/" + path);
},2200)
}
else{
this.$router.push("/" + path);
}

},
_getSingerList() {
this.singers = this._normalizeSinger(this.dataca)
},
_normalizeSinger(list) {

if (!list){
return
}

let map = {
hot: {
title: this.HOT_NAME,
items: []
}
}

list.forEach((item,index) =>{
const key = (item.enName.substr(0,1)).toUpperCase()

if (!map[key]){
map[key] = {
title:key,
items:[]
}
}
map[key].items.push({
name:item.siteName,
id:item.cityNo,
full_name:item.enName,
short_name:item.enName,
siteNo:item.siteNo
})
if(item.cityNo===(this.$until.getUrlParam("cityNo")||localStorage.getItem('jbStorage')&&JSON.parse(localStorage.getItem('jbStorage')).city&&JSON.parse(localStorage.getItem('jbStorage')).city.id||localStorage.getItem("$currentCity"))){
map['hot'].items.push({
name:item.siteName,
id:item.cityNo,
full_name:item.enName,
short_name:item.enName,
siteNo:item.siteNo
})
}
})

let ret = []
let hot = []
for(let key in map) {
let val = map[key]
if (val.title.match(/[a-zA-Z]/)){
ret.push(val)
} else if (val){

}

}
ret.sort((a,b) =>{
return a.title.charCodeAt(0) - b.title.charCodeAt(0)
})

return hot.concat(ret)
}
},
components:{
ListView
}
}




// WEBPACK FOOTER //
// ./src/components/common/station.vue